import React, { useState } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import OrderTable from '../../components/OrderTable/OrderTable';
import { generateFabcoGuid } from '../../services/endpoints';
import './Order.scss';

const Order = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isGeneratingOrderNo, setIsGeneratingOrderNo] = useState(false);

  const handleCreateOrder = async () => {
    try {
      setIsGeneratingOrderNo(true);
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const sessionUserId = localStorage.getItem('sessionUserId');
      const userId = sessionUserId || userData?.sessionUserId;
      
      if (!userId || userId === 'undefined') {
        console.error('User session not found');
        return;
      }

      const response = await generateFabcoGuid({ SessionUserId: userId });
      
      if (response?.data?.Result?.ErrorCode === 0 && response?.data?.OrderNo) {
        // Navigate to create order page with the generated OrderNo
        navigate('/orders/create', { 
          state: { 
            generatedOrderNo: response.data.OrderNo 
          } 
        });
      } else {
        console.error('Failed to generate OrderNo:', response?.data?.Result?.ErrorDescription);
        // Still navigate to create page even if OrderNo generation fails
        navigate('/orders/create');
      }
    } catch (error) {
      console.error('Error generating OrderNo:', error);
      // Still navigate to create page even if there's an error
      navigate('/orders/create');
    } finally {
      setIsGeneratingOrderNo(false);
    }
  };

  return (
    <div className="customer-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('orders')}</div>
        <OrderTable />
      </CContainer>
      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateOrder}
        disabled={isGeneratingOrderNo}
        title={isGeneratingOrderNo ? t('generatingOrderNo') : t('createOrder')}
      >
        {isGeneratingOrderNo ? (
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <CIcon icon={cilPlus} size="lg" />
        )}
      </CButton>
    </div>
  );
};

export default Order; 